import { FC } from "react";
import { FieldGroup, IFormProps } from ".";
import CurrentUserViewModel from "../Models/CurrentUserViewModel";

interface ICurrentUserControlProps extends IFormProps {
	model: CurrentUserViewModel;
};

const CurrentUserControl: FC<ICurrentUserControlProps> = ( { model } ) => {

	return (
		<FieldGroup
			hidden={ !model.ControlVisibility }
			name={model.FullPath} 
			title={model.Caption} 
			width={model.Width ?? 12}
			readOnly={ !model.ControlEnabling }
			isInvalid={model.notValidClass} 
			errorMsg={model.errorMessage}
			isRequired={model.IsMandatory}
			tooltip={model.Tooltip}
		>
			<p dangerouslySetInnerHTML={{ __html: model.Value }} />
		</FieldGroup>
	);
};

export default CurrentUserControl;
